import { render, staticRenderFns } from "./SelectInput.vue?vue&type=template&id=a0b5b8e6&scoped=true"
import script from "./SelectInput.vue?vue&type=script&lang=js"
export * from "./SelectInput.vue?vue&type=script&lang=js"
import style0 from "./SelectInput.vue?vue&type=style&index=0&id=a0b5b8e6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0b5b8e6",
  null
  
)

export default component.exports